"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = IPTDisclaimer;
var jsx_runtime_1 = require("react/jsx-runtime");
function IPTDisclaimer(props) {
    return ((0, jsx_runtime_1.jsx)("div", { className: props.cssClass, children: "Please note, all figures include Insurance Premium Tax" }));
}
;
//# sourceMappingURL=IPTDisclamer.js.map